module.exports = __webpack_public_path__ + "img/1191100523.f2ece99a.jpg";